import { Component, OnInit, Optional } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  KeycloakEvent,
  KeycloakEventType,
  KeycloakService,
} from 'keycloak-angular';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/user.service';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { Router } from '@angular/router';
import Validation from '../../utils/Validation';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../../environments/environment";
import { LoginService } from '../../services/login.service';

@Component({
    selector: 'app-registration-page',
    templateUrl: './registration-page.component.html',
    styleUrls: ['./registration-page.component.css'],
    standalone: false
})
export class RegistrationPageComponent implements OnInit {
  brokerUserSubmitted: boolean = false;
  normalBrokerUserSubmitted: boolean = false;

  brokerForm: FormGroup = new FormGroup({});
  normalBrokerForm: FormGroup = new FormGroup({});
  isSuccessful: boolean = false;
  isSignUpFailed: boolean = true;
  errorMessage: string = '';
  loading: boolean = false;
  initialLoading: boolean = false;
  countryListFailed: boolean = false;
  isLoggedIn: boolean = false;
  role: string = '';
  user: any;
  countries: any[] = [];
  institutions: any;
  institutionsDIFC: any;

  isBrokerSignup: boolean = false;
  isNormalBrokerSignup: boolean = false;

  registrationSuccess: boolean = false;
  requestId: number = 0;
  registeredEmail: string = '';
  email: string = '';
  email1: string = '';
  password: string = '';
  showPasswordStrength: boolean = false;
  passwordEntered: boolean = false;
  passwordNotNull: boolean = false;

  region: string = 'asia';
  defaultCountryCodes: string[] = [];
  defaultCountryCode: string = '';

  loadingInstitutionApiData = false;
  apis: any;
  institutionId: any[] = [];
  defaultInstitution: any;
  defaultRegion: any;
  isDisabled: boolean = true;
  userRole: any;
  defaultCountryName: string = '';

  professions = [
    'Software Developer',
    'System Architect',
    'DevOps Engineer',
    'Data Engineer',
    'Security Professional',
    'Quality Assurance Engineer',
    'Technical Support Engineer',
    'Product Manager',
    'Compliance Officer',
    'Business Analyst',
    'UI/UX Engineer',
    'Data Scientist',
    'Financial Analyst',
    'Project Manager',
    'Operations Manager',
  ];

  siteKey: any;
  validCaptcha: boolean = false;
  allowedCountryCodes: any[] = [];

  /** Set via modal data when opened by RegistrationModalService. */
  openedAsModal = false;

  async login() {
    this.modalRef?.close();
    await this.loginService.login();
  }

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private tokenStorage: TokenStorageService,
    private userService: UserService,
    private router: Router,
    private keycloakService: KeycloakService,
    //public modalRef: MdbModalRef<RegistrationPageComponent>
    private httpClient: HttpClient,
    private loginService: LoginService,
    @Optional() public modalRef: MdbModalRef<RegistrationPageComponent> | null,
  ) {}

  ngOnInit(): void {
    const registrationMode =
      this.openedAsModal || this.router.url.includes('/registration');
    this.isBrokerSignup = registrationMode;
    this.isNormalBrokerSignup = registrationMode;

    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.user = this.tokenStorage.getUser();
      this.role = this.user.role;
    }
    if (this.role != 'brokerAdmin') {
      this.initializeBrokerForm();
    } else if (this.role == 'brokerAdmin') {
      this.initializeNormalBrokerForm();
    }

    this.loadIp();
    this.countryList();

    if (!this.isBrokerSignup) {
      this.institutionList();
    }
    this.siteKey = environment.recaptcha.siteKey;
  }
  loadIp() {
    this.httpClient.get('https://ipinfo.io/json').subscribe(
      (value: any) => {
        this.defaultCountryCode = value.country.toUpperCase();
        this.defaultCountryCodes = [value.country.toLowerCase()];

        const matchedCountry = this.countries.find(
          (c) => c.countryCode === this.defaultCountryCode,
        );

        if (matchedCountry) {
          this.defaultCountryName = matchedCountry.countryName;
          this.brokerForm.patchValue({
            brokerCountry: matchedCountry.countryId,
          });
          this.normalBrokerForm.patchValue({
            normalBrokerCountry: matchedCountry.countryId,
          });
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  countryList() {
    this.initialLoading = true;
    this.userService.getCountryList().subscribe({
      next: (data: any) => {
        if (!data?.countryList) {
          this.countryListFailed = true;
          this.initialLoading = false;
          return;
        }
        this.countries = data.countryList.sort((a: any, b: any) =>
          a.countryName > b.countryName ? 1 : -1,
        );
        this.allowedCountryCodes = this.countries.map((country: any) =>
          country.countryCode.toLowerCase(),
        );
        console.log('allowedCountryCodes', this.allowedCountryCodes);
        this.initialLoading = false;
      },
      error: () => {
        // render the form anyway — the phone input falls back to the
        // full country list and the country select stays empty
        this.countryListFailed = true;
        this.initialLoading = false;
      },
    });
  }

  getemail(event: any) {
    this.email = event.target.value;
    const username = this.email;

    this.brokerForm.patchValue({
      brokerUserName: username,
    });
  }

  getRole(event: any) {
    this.userRole = event.target.value;
  }

  checkBoxFunc(e: any) {
    if (e.target.checked) {
      this.email1 = this.email;
    } else {
      this.email1 = '';
    }
  }

  passwordChanged(passwordStrength: any) {
    if (passwordStrength > 90) {
      setTimeout(() => {
        this.brokerForm.controls['brokerPassword'].setErrors(null);
      }, 0);
    } else {
      setTimeout(() => {
        this.brokerForm.controls['brokerPassword'].setErrors({ invalid: true });
      }, 0);
    }
  }

  onNewPasswordFocus() {
    this.showPasswordStrength = true;
  }

  onNewPasswordBlur() {
    this.showPasswordStrength = false;
  }

  onEmailChange(event: any): void {
    this.getemail(event);
    this.checkUserName(event);
  }

  getPassword(event: any) {
    if (event.target.value.length == 0) {
      this.passwordEntered = false;
    } else {
      this.passwordEntered = true;
      this.password = event.target.value;
    }
  }

  checkUserName(event: any) {
    const userName = event.target.value;
    const hasUpperCase = /[A-Z]/.test(userName);

    if (hasUpperCase) {
      console.warn('Username should not contain uppercase letters.');
      this.brokerForm.controls['brokerEmail'].setErrors({
        containsUpperCase: true,
      });
      return;
    }
    this.userService.validateUserName(userName).subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.brokerForm.controls['brokerEmail'].setErrors(null);
        } else if (data.isUnique == false) {
          console.warn('email already exists');
          this.brokerForm.controls['brokerEmail'].setErrors({
            alreadyExist: true,
          });
        } else {
          console.warn('invalid', data);
          this.brokerForm.controls['brokerEmail'].setErrors({ invalid: true });
        }
      },
      error: (err) => {
        console.error('invalid ', err);
        this.brokerForm.controls['brokerUserName'].setErrors({ invalid: true });
      },
    });
  }

  checkNormalBrokerUserName(userName: any) {
    const hasUpperCase = /[A-Z]/.test(userName);

    if (hasUpperCase) {
      console.warn('Username should not contain uppercase letters.');
      this.normalBrokerForm.controls['brokerUserName'].setErrors({
        containsUpperCase: true,
      });
    }
    this.userService.validateUserName(userName).subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.normalBrokerForm.controls['normalBrokerUserName'].setErrors(
            null,
          );
        } else if (data.unique == false) {
          console.warn('username is already exist');
          this.normalBrokerForm.controls['normalBrokerUserName'].setErrors({
            alreadyExist: true,
          });
        } else {
          console.warn('invalid', data);
          this.normalBrokerForm.controls['normalBrokerUserName'].setErrors({
            invalid: true,
          });
        }
      },
      error: (err) => {
        console.error('invalid ', err);
        this.brokerForm.controls['normalBrokerUserName'].setErrors({
          invalid: true,
        });
      },
    });
  }

  checkConfirmPassword(event: any) {
    if (event != null || event != '') {
      this.passwordNotNull = true;
    } else {
      this.passwordNotNull = false;
    }
  }

  institutionList() {
    this.initialLoading = true;
    this.userService.getInstitutionList().subscribe((data: any) => {
      this.institutions = data.institutionList.sort((a: any, b: any) =>
        a.institutionCode > b.institutionCode ? 1 : -1,
      );
      this.initialLoading = false;
    });
  }

  initializeNormalBrokerForm(): void {
    this.normalBrokerForm = this.formBuilder.group(
      {
        normalBrokerFirstName: ['', [Validators.required]],
        normalBrokerLastName: ['', [Validators.required]],
        normalBrokerCompany: ['', [Validators.required]],
        normalBrokerProfession: ['', [Validators.required]],
        normalBrokerEmail: ['', [Validators.required, Validators.email]],
        normalBrokerContactNo: [''],
        normalBrokerCountry: ['', [Validators.required]],
        normalBrokerUserName: ['', [Validators.required]],
        normalBrokerInstitution: [
          this.role == 'brokerAdmin' ? this.user.institution : '',
        ],
        normalBrokerPassword: [
          '',
          this.isBrokerSignup ? null : Validators.minLength(8),
        ],
        normalBrokerConfirmPassword: [''],
        normalBrokerRegion: [
          this.role == 'brokerAdmin' ? this.user.region : '',
        ],
        // userRole:['', [Validators.required]],
      },
      {
        validators: [
          Validation.match(
            'normalBrokerPassword',
            'normalBrokerConfirmPassword',
          ),
        ],
      },
    );
  }

  initializeBrokerForm(): void {
    this.brokerForm = this.formBuilder.group(
      {
        brokerFullName: ['', [Validators.required]],
        brokerCompany: ['', [Validators.required]],
        brokerProfession: [''],
        brokerEmail: ['', [Validators.required, Validators.email]],
        brokerContactNo: [''],
        brokerCountry: ['', [Validators.required]],
        brokerUserName: [''],
        brokerInstitution: [
          '',
          this.isBrokerSignup ? null : [Validators.required],
        ],
        brokerPassword: [
          '',
          this.isBrokerSignup
            ? null
            : //Validators.required,
              Validators.minLength(8),
        ],
        brokerConfirmPassword: [''],
        region: ['', this.isBrokerSignup ? null : [Validators.required]],
        userRole: ['', this.isBrokerSignup ? null : [Validators.required]],
        FintechApiEnableCheck: [''],
        FixApiEnableCheck: [''],
        AccountApiEnableCheck: [''],
        DwmEnableCheck: [''],
        FeedApiEnableCheck: [''],
        recaptcha: [
          null,
          this.isBrokerSignup ? Validators.required : Validators.nullValidator,
        ],
      },
      {
        validators: [
          Validation.match('brokerPassword', 'brokerConfirmPassword'),
        ],
      },
    );
  }

  getInstitutionalApiListByInstitutionCode(institution: any) {
    this.loadingInstitutionApiData = true;
    this.userService
      .getInstitutionalApiListByInstitutionCode(institution)
      .subscribe((data: any) => {
        this.apis = data.institutionApiList;
        this.defaultInstitution = institution;
        this.defaultRegion = this.user.region;
        this.loadingInstitutionApiData = false;
      });
  }

  onClickSubmitBroker() {
    this.brokerUserSubmitted = true;
    if (this.brokerForm.invalid) {
      this.toastr.clear();
      this.toastr.error(
        'We require more information about you',
        'Cannot proceed with registration',
      );
      return;
    }
    this.loading = true;

    const fullName = this.brokerForm.value.brokerFullName.trim().split(/\s+/);
    const brokerFirstName = fullName[0];
    const brokerLastName = fullName.slice(1).join(' '); // in case there's a middle name
    const {
      brokerCompany,
      brokerProfession,
      brokerEmail,
      brokerContactNo,
      brokerCountry,
      brokerUserName,
      brokerInstitution,
      brokerPassword,
      region,
      userRole,
      FintechApiEnableCheck,
      FixApiEnableCheck,
      AccountApiEnableCheck,
      DwmEnableCheck,
      FeedApiEnableCheck,
    } = this.brokerForm.value;

    if (this.isBrokerSignup) {
      if (this.brokerForm.value.brokerEmail.endsWith('@gtngroup.com')) {
        this.userService
          .registerBroker(
            brokerFirstName,
            brokerLastName,
            brokerCompany,
            brokerProfession,
            brokerContactNo
              ? brokerContactNo.dialCode + '-' + brokerContactNo.number
              : '',
            brokerCountry,
            brokerEmail,
            brokerUserName,
            region,
            'internalUser',
            // FintechApiEnableCheck == true ? 1 : 0,
            // FixApiEnableCheck == true ? 1 : 0,
            // AccountApiEnableCheck == true ? 1 : 0,
            // DwmEnableCheck == true ? 1 : 0,
            1,
            1,
            0,
            0,
            0,
          )
          .subscribe({
            next: (data) => {
              this.loading = false;
              if (data.status == 'SUCCESS') {
                this.isSuccessful = true;
                this.isSignUpFailed = false;
                this.registrationSuccess = true;
                this.requestId = data.requestId;
                this.registeredEmail = data.email;
                this.userService
                  .approveBrokerUser(
                    brokerEmail.endsWith('@gtngroup.com')
                      ? 'internalUser'
                      : 'normalBroker',
                    this.requestId,
                    'gtn_admin',
                    581,
                    'global sandbox',
                    1,
                    1,
                    0,
                    0,
                    0,
                  )
                  .subscribe({
                    next: (data) => {
                      this.loading = false;
                      if (data.status == 'SUCCESS') {
                        // this.toastr.success("Broker approved successfully");
                      } else {
                        this.toastr.error(
                          data.reason,
                          'Failed to approve Broker user',
                        );
                      }
                    },
                    error: (err) => {
                      this.loading = false;
                      this.toastr.error(
                        err.error.message,
                        'Failed to approve  Broker user',
                      );
                    },
                  });
              } else {
                this.errorMessage = data.reason;
                this.isSignUpFailed = true;
                this.toastr.error(
                  this.errorMessage,
                  'Broker user registration failed',
                );
              }
            },
            error: (err) => {
              this.loading = false;
              this.errorMessage = err.error.message;
              this.isSignUpFailed = true;
              this.toastr.error(
                this.errorMessage,
                'Broker user registration failed',
              );
            },
          });
      } else {
        this.userService
          .registerBroker(
            brokerFirstName,
            brokerLastName,
            brokerCompany,
            brokerProfession,
            brokerContactNo
              ? brokerContactNo.dialCode + '-' + brokerContactNo.number
              : '',
            brokerCountry,
            brokerEmail,
            brokerUserName,
            region,
            'normalBroker',
            // FintechApiEnableCheck == true ? 1 : 0,
            // FixApiEnableCheck == true ? 1 : 0,
            // AccountApiEnableCheck == true ? 1 : 0,
            // DwmEnableCheck == true ? 1 : 0,
            1,
            1,
            0,
            0,
            0,
          )
          .subscribe({
            next: (data) => {
              this.loading = false;
              if (data.status == 'SUCCESS') {
                this.isSuccessful = true;
                this.isSignUpFailed = false;
                this.registrationSuccess = true;
                this.requestId = data.requestId;
                this.registeredEmail = data.email;
                this.userService
                  .approveBrokerUser(
                    brokerEmail.endsWith('@gtngroup.com')
                      ? 'internalUser'
                      : 'normalBroker',
                    this.requestId,
                    'gtn_admin',
                    581,
                    'global sandbox',
                    1,
                    1,
                    0,
                    0,
                    0,
                  )
                  .subscribe({
                    next: (data) => {
                      this.loading = false;
                      if (data.status == 'SUCCESS') {
                        // this.toastr.success("Broker approved successfully");
                      } else {
                        this.toastr.error(
                          data.reason,
                          'Failed to approve Broker user',
                        );
                      }
                    },
                    error: (err) => {
                      this.loading = false;
                      this.toastr.error(
                        err.error.message,
                        'Failed to approve  Broker user',
                      );
                    },
                  });
              } else {
                this.errorMessage = data.reason;
                this.isSignUpFailed = true;
                this.toastr.error(
                  this.errorMessage,
                  'Broker user registration failed',
                );
              }
            },
            error: (err) => {
              this.loading = false;
              this.errorMessage = err.error.message;
              this.isSignUpFailed = true;
              this.toastr.error(
                this.errorMessage,
                'Broker user registration failed',
              );
            },
          });
      }
    } else {
      this.userService
        .createBroker(
          brokerFirstName,
          brokerLastName,
          brokerCompany,
          brokerProfession,
          brokerContactNo
            ? brokerContactNo.dialCode + '-' + brokerContactNo.number
            : '',
          brokerCountry,
          brokerEmail,
          brokerUserName,
          brokerInstitution,
          brokerPassword ? brokerPassword : null,
          this.user.username2,
          region,
          userRole,
        )
        .subscribe({
          next: (data) => {
            this.loading = false;
            if (data.status == 'SUCCESS') {
              this.isSuccessful = true;
              this.isSignUpFailed = false;
              this.toastr.success(
                'Broker user created successfully',
                'Success',
              );
              setTimeout(() => {
                this.reloadPage();
              }, 1000);
            } else {
              this.errorMessage = data.reason;
              this.isSignUpFailed = true;
              this.toastr.error(
                this.errorMessage,
                'Unable to create Broker user',
              );
            }
          },
          error: (err) => {
            this.loading = false;
            this.errorMessage = err.error.message;
            this.isSignUpFailed = true;
            this.toastr.error(
              this.errorMessage,
              'Unable to create Broker user',
            );
          },
        });
    }
  }

  onClickSubmitNormalBroker() {
    this.normalBrokerUserSubmitted = true;
    if (this.normalBrokerForm.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      return;
    }
    this.loading = true;
    const {
      normalBrokerFirstName,
      normalBrokerLastName,
      normalBrokerCompany,
      normalBrokerProfession,
      normalBrokerEmail,
      normalBrokerContactNo,
      normalBrokerCountry,
      normalBrokerUserName,
      normalBrokerInstitution,
      normalBrokerPassword,
      normalBrokerRegion,
      FintechApiEnableCheck,
      FixApiEnableCheck,
      AccountApiEnableCheck,
      DwmEnableCheck,
      FeedApiEnableCheck,
    } = this.normalBrokerForm.value;

    if (this.isNormalBrokerSignup) {
      this.userService
        .registerBroker(
          normalBrokerFirstName,
          normalBrokerLastName,
          normalBrokerCompany,
          normalBrokerProfession,
          normalBrokerContactNo
            ? normalBrokerContactNo.dialCode +
                '-' +
                normalBrokerContactNo.number
            : '',
          normalBrokerCountry,
          normalBrokerEmail,
          normalBrokerUserName,
          normalBrokerRegion,
          1,
          // FintechApiEnableCheck == true ? 1 : 0,
          // FixApiEnableCheck == true ? 1 : 0,
          // AccountApiEnableCheck == true ? 1 : 0,
          // DwmEnableCheck == true ? 1 : 0,
          1,
          0,
          0,
          0,
          0,
        )
        .subscribe({
          next: (data) => {
            this.loading = false;
            if (data.status == 'SUCCESS') {
              this.isSuccessful = true;
              this.isSignUpFailed = false;
              this.registrationSuccess = true;
              this.requestId = data.requestId;
              this.registeredEmail = data.email;
              this.toastr.success(
                'Normal Broker user registration success',
                'Success',
              );
            } else {
              this.errorMessage = data.reason;
              this.isSignUpFailed = true;
              this.toastr.error(
                this.errorMessage,
                'Normal Broker user registration failed',
              );
            }
          },
          error: (err) => {
            this.loading = false;
            this.errorMessage = err.error.message;
            this.isSignUpFailed = true;
            this.toastr.error(
              this.errorMessage,
              'Normal Broker user registration failed',
            );
          },
        });
    } else {
      this.userService
        .createNormalBroker(
          normalBrokerFirstName,
          normalBrokerLastName,
          normalBrokerCompany,
          normalBrokerProfession,
          normalBrokerContactNo
            ? normalBrokerContactNo.dialCode +
                '-' +
                normalBrokerContactNo.number
            : '',
          normalBrokerCountry,
          normalBrokerEmail,
          normalBrokerUserName,
          normalBrokerInstitution,
          normalBrokerPassword ? normalBrokerPassword : null,
          this.user.username2,
          normalBrokerRegion,
        )
        .subscribe({
          next: (data) => {
            this.loading = false;
            if (data.status == 'SUCCESS') {
              this.isSuccessful = true;
              this.isSignUpFailed = false;
              this.toastr.success(
                'Normal Broker user created successfully',
                'Success',
              );
              setTimeout(() => {
                this.reloadPage();
              }, 1000);
            } else {
              this.errorMessage = data.reason;
              this.isSignUpFailed = true;
              this.toastr.error(
                this.errorMessage,
                'Unable to create Normal Broker user',
              );
            }
          },
          error: (err) => {
            this.loading = false;
            this.errorMessage = err.error.message;
            this.isSignUpFailed = true;
            this.toastr.error(
              this.errorMessage,
              'Unable to create Normal Broker user',
            );
          },
        });
    }
  }

  onCaptchaResolved(captchaResponse: string | null) {
    if (!captchaResponse) {
      console.warn('Captcha response is null or empty');
      return;
    }
    this.brokerForm.controls['recaptcha'].setValue(captchaResponse);
    this.userService.validateCaptchaToken(captchaResponse).subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.validCaptcha = true;
        }
      },
      error: (err) => {
        console.error('invalid ', err);
      },
    });
  }

  reloadPage(): void {
    window.location.reload();
  }

  get formBrokerControl(): { [key: string]: AbstractControl } {
    return this.brokerForm.controls;
  }
  get formNormalBrokerControl(): { [key: string]: AbstractControl } {
    return this.normalBrokerForm.controls;
  }
}
